import { setupFabric } from '@/libraries'

export default function setup (app) {
  setupApp()
  setupFabric()
}

function setupApp () {
  
  const initialState = window.__INITIAL_STATE__
  if (initialState.app.isHmtDevice) {
    const wmlScript = document.createElement('script')
    wmlScript.src = '/libs/wearml/wearml_engine-updated.js'
    document.body.appendChild(wmlScript)
    document.body.setAttribute('tabindex', '-1')
    document.body.setAttribute('title', 'hf_no_overlay')
  }  
}

